import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CarouselCard from './CarouselCard.js';
import { ReviewAPI } from '../../api';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// MuiContainer-root MuiContainer-fixed MuiContainer-disableGutters MuiContainer-maxWidthLg

const useStyles = makeStyles({
  root: {
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  cards: {
    margin: '0.5rem',
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    justifyContent: 'flex-start',
    padding: '1rem',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

const Carousel = () => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const scrollRef = React.useRef(null);
  const [data, setData] = React.useState(null);
  const scrollAmount = (smallScreen) ? 353 : 393;

  const fetchData = async () => {
    try {
      const { payload } = await ReviewAPI.getCarouselItems();
      setData(payload);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  const shiftCard = direction => {
    if (direction === 'right') {
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      scrollRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  };

  const skeleton = () => {
    return (
      <React.Fragment>
        <CarouselCard data={null} />
        <CarouselCard data={null} />
        <CarouselCard data={null} />
      </React.Fragment>
    );
  };

  const cards = () => {
    return (
      <React.Fragment>
        {data.map((d, i) =>
          <CarouselCard
            key={i}
            data={d}
          />
        )}
      </React.Fragment>
    );
  };

  React.useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  return (
    <div className={classes.root}>
      <IconButton aria-label="carousel-left" onClick={()=>shiftCard('left')}>
        <ChevronLeftIcon />
      </IconButton>
      <section className={classes.cards} ref={scrollRef}>
        {data === null ? skeleton() : cards()}
      </section>
      <IconButton aria-label="carousel-right" onClick={()=>shiftCard('right')}>
        <ChevronRightIcon />
      </IconButton>
    </div>
  );
};

export default Carousel;
